module.exports = __webpack_public_path__ + "static/media/7.461cfbb0.jpg";